export const tdaDesktopHeight = 220;
export const tdaDesktopHeight = 220;
